import React,{useContext,useState,useEffect,createContext} from "react";
import { AuthContext } from "../../AuthContext";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
export const HotelOwnerContext=createContext()
export const HotelOwnerProvider=({children})=>{
   
    const [hotelOnwerData,setHotelOwnerData]=useState({
      name:"",
      email:"",
      id:0,
      profile:"",
      username:"",
      role:"" 
    })
    const navigate = useNavigate();
    const { token } = useContext(AuthContext);
    const [data,setData]=useState([])
    // State to hold the customers of the  hotel that the hotelOwner has 
    const [hotelCustomers,setHotelCustomers]=useState([])
    // State to hold the farmers of the hotel that the hotelOwner has 
    const [hotelFarmers,setHotelFarmers]=useState([])
    // State to hold the hotel that a hotelOwner does not have
    const [availableHotels, setAvailableHotels] = useState([]);   
    // State to determine whether request being sent is ether a post/delete
    const [relToDelete,setRelToDelete]=useState(false)
    // State to hold the hotels for a hotel owner
    const [hotelOwnerHotels,setHotelOwnerHotels]=useState([])
    // State to hold admins for a user to communicate with
    const [admins,setAdmins]=useState([])    
   const baseUrl=process.env.REACT_APP_SECOND_BACKEND_URL;
    useEffect(() => {
      if (token) {
          // Decode token and set user details
          const decodedToken = jwtDecode(token);
          const{role,name,username,email,id,profile}=decodedToken?.sub           
  
          // Navigate to unauthorized page if role is not hotel_owner
          if (role !== "hotel_owner") {
              navigate("/unauthorized");
          }
           fetcHotelOwnerData(id);          
          setHotelOwnerData((prev)=>({
            ...prev,
            name:name?name:prev?.name,
            username:username?username:prev?.username,
            email:email?email:prev?.email,
            profile:profile?profile:prev?.profile,
            id:id?id:prev?.id,
            role:role?role:prev?.role,            
          }))
      }
      
  }, [token]); // Only run when token changes
  
  useEffect(()=>{
    if (hotelOnwerData?.username){
      formik.setFieldValue("hotel_owner_username",hotelOnwerData?.username)
    }
  },[hotelOnwerData?.username])
  useEffect(() => {
      if (token && data.length > 0) {
          // Fetch all hotels once data is available
          axios
              .get(`${baseUrl}/hotels`, {
                  headers: {
                      Authorization: `Bearer ${token}`,
                  },
              })
              .then((res) => {
                  const allHotels = res.data;
                  if (data[0]?.Hotels?.length > 0) {
                      const ownerHotelNames = data[0].Hotels.map(hotel => hotel.name);
                      setAvailableHotels(allHotels.filter(hotel => !ownerHotelNames.includes(hotel.name)));
                  } else {
                      setAvailableHotels(allHotels);
                  }
              })
              .catch((error) => {
                  console.log("Error fetching hotels", error);
              });
      }
  }, [token, data]); // Run when token or data changes
  
  

// Function to fetch hotel_owner data
const fetcHotelOwnerData=(id)=>{
  axios
  .get(`${baseUrl}/hotel_owners/${id}`, {
      headers: {
          Authorization: `Bearer ${token}`,
      },
  })
  .then((response) => {
      const allData = response.data;              
      setData(allData)
      let allHotels=allData[0]?.AllHotels;
      if (allData[0]?.Hotels?.length > 0) {
        setHotelOwnerHotels(allData[0].Hotels)
        // get the hotels ids
        const hotelOwnerHotelIds=allData[0].Hotels.map(hotel=>hotel.id);       
        if(allData[0].AllHotels.length>0){
          const filtteredHotels=allData[0].AllHotels.filter(hotel=>!hotelOwnerHotelIds.includes(hotel.id))
          setAvailableHotels(filtteredHotels);
        }       
      
        const newHotelCustomers=allData[0].Hotels.flatMap(hotel=>hotel.customers)
        if(newHotelCustomers.length>0){
          const uniqueHotelCustomers=[...new Set(newHotelCustomers.map(customer=>customer.username))].map(username=>newHotelCustomers.find(customer=>customer.username===username))
           setHotelCustomers(uniqueHotelCustomers)
        }
       
        const newHotelFarmers=allData[0].Hotels.flatMap(hotel=>hotel.farmers)
        if(newHotelFarmers.length>0){
          const uniqueHotelFarmers=[...new Set(newHotelFarmers.map(farmer=>farmer.username))].map(username=>newHotelFarmers.find(farmer=>farmer.username===username))
          setHotelFarmers(uniqueHotelFarmers)
        }   
      }
      else{
        setAvailableHotels(allData[0]?.AllHotels)
      }

  })
  .catch((error) => {
      console.error("Error fetching hotel owners", error);
  });

}
// Run this useffect i  case in a change in admins
useEffect(()=>{
  HotelOwnerFechAdmins()
},[])
// Function for fetching admins
const HotelOwnerFechAdmins=async()=>{
    try {
      const res=await fetch(`${baseUrl}/admins`,{
        headers:{
          "Authorization" :`Bearer ${token}`
        }
      })
      if (res.ok){
        const newData=await res.json()
        setAdmins(newData)
      }     
        else{
          console.error(`Error fetching admins ${res.statusText}`)
        }
    } catch (error) {
      console.error(`Error fetching admins ${error}`)
    }
}
// Functioning for fetching admins
const requestAddHotel=async(values)=>{
  try {
    const res=await fetch(`${baseUrl}/login/admin/hotel_owners`,{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
        "Authorization" :`Bearer ${token}`
      },
      body:JSON.stringify(values)
    })
    if (res.ok){
      alert(`${values.hotel_name} added successfully`)
      fetcHotelOwnerData(hotelOnwerData?.id)     
    }
    else{
     let response=await res.json()
     alert(`An error occurred sending request ${response.Error || response.Message}`)
    }
  } catch (error) {
    console.error("An error occurred ",error)
  }
}
useEffect(()=>{
  if(hotelOnwerData?.profile){
  fetchProfile() 
  } 
  
},[hotelOnwerData?.profile])
const fetchProfile=async()=>{
  try {
    const res=await fetch(`${baseUrl}/uploads/${hotelOnwerData?.username}_profile_picture.png`,{
      headers:{
    Authorization:`Bearer ${token}`
}
    })
   if (res.ok) {
    let blob=await res.blob()
    let url=URL.createObjectURL(blob)
    setHotelOwnerData((prev)=>({
      ...prev,
      profile:url
    }))
   }
   else{
    setHotelOwnerData((prevValues)=>({
      ...prevValues,
      profile:""
    }))
   }
  } catch (error) {
    console.error(`An error occurred fetching profiles`,error)
  }
  
}


const requestDeleteHotel=async(values)=>{
  try {
    if(!window.confirm(`Are you sure you want to delete ${values.hotel_name}`)) return;
    else{
    const res=await fetch(`${baseUrl}/login/admin/hotel_owners`,{
      method:"DELETE",
      headers:{
        "Content-Type":"application/json",
        "Authorization" :`Bearer ${token}`
      },
      body:JSON.stringify(values)
    })
    if (res.ok){
      alert(`${values.hotel_name} deleted successfully`) 
      fetcHotelOwnerData(hotelOnwerData?.id)    
    }
    else{
      let response=await res.json()
      alert(`An error occurred deleting hotel ${response.Error || response.Message}`)
    }
  }
} catch (error) {
    console.error("An error occurred ",error)
  }
}
    const formik = useFormik({
        initialValues: {
          hotel_name:"",
          hotel_owner_username:""
        },
        validationSchema:yup.object().shape({
          hotel_name:yup.string("hotel_name should be a string").required("hotel_name is required").typeError("hotel_name is required"),
          hotel_owner_username:yup.string("hotel_owner_username should be a string").required("hotel_owner_username is required").typeError("hotel_owner_username is required")
        }),
        onSubmit : async (values,{setSubmitting}) =>{
            try {
              if(relToDelete){
                await requestDeleteHotel(values)
                setRelToDelete(false)
              }
              else{
                await requestAddHotel(values)
                setRelToDelete(false)
              }
            } catch (error) {
              console.error("An error ocuured",error)
            }
            finally{
              setSubmitting(false)
            }
        }
    });
   
  
    const handleSendMessage=async(values)=>{
        try {
          const res=await fetch(`${baseUrl}/messages`,{
            method:"POST",
            headers:{
                "Content-Type":"application/json",
                "Authorization":`Bearer ${token}`
            },
            body:JSON.stringify(values)
          })  
          if (res.ok){           
            
          }
          else{
            // alert("An error ocuurred")
            console.error("An error occurred sending message",res.statusText)
          }
        } catch (error) {
            console.error("An error occurred sending message",error)
        }
      }
  
    // Pagination states
    const [currentPage,setCurrentPage]=useState(1)
    const [postsPerPage,setPostsPerPage]=useState(4)
    const indexOfLastPost=currentPage*postsPerPage
    const indexOfFirstPost=indexOfLastPost-postsPerPage
    const paginate=(num)=>{
      setCurrentPage(num)
    }
    // Pagination
    const newHotelData=hotelOwnerHotels.length>4?hotelOwnerHotels.slice(indexOfFirstPost,indexOfLastPost):hotelOwnerHotels
      const contextValues={

       baseUrl, hotelOnwerData,hotelCustomers,hotelFarmers,data,availableHotels,baseUrl,relToDelete,requestAddHotel,requestDeleteHotel,formik,handleSendMessage,setRelToDelete,newHotelData,hotelOwnerHotels,postsPerPage,currentPage,paginate,admins
      }
      return (
        <div>
            <HotelOwnerContext.Provider value={contextValues}>
                {children}
            </HotelOwnerContext.Provider>
        </div>
      )
}
